
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Button, FormControl } from 'react-bootstrap';
import cx from 'classnames';

import DateRange from '../DateRange';
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import MobileDateRange from '../MobileDateRange';

import { setPersonalizedValues } from '../../../actions/personalized';
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import history from '../../../core/history';
import messages from '../../../locale/messages';
import { searchFormSuggestSelect, changeSearchForm } from '../../../helpers/GeoSuggest/updateSearchForm';

import searchIcon from '/public/SiteIcons/searchIconHome.svg';

import bt from '../../commonStyle.css';
import s from './SearchForm.css';

class SearchForm extends React.Component {
  static propTypes = {
    setPersonalizedValues: PropTypes.any.isRequired,
    personalized: PropTypes.shape({
      location: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
      chosen: PropTypes.number,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      personCapacity: PropTypes.number,
      formatMessage: PropTypes.any,
      isOneTotalToggle: PropTypes.bool,
    }),
    settingsData: PropTypes.shape({
      listSettings: PropTypes.array.isRequired
    }).isRequired
  };

  static defaultProps = {
    listingFields: []
  };

  static defaultProps = {
    personalized: {
      location: null,
      lat: null,
      lng: null,
      startDate: null,
      endDate: null,
      personCapacity: null,
      chosen: null
    },
    settingsData: {
      listSettings: []
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      mobileDevice: false,
      personCapacity: [],
      smallDevice: false,
      verySmallDevice: false,
      isOneTotalToggle: false
    },
      this.handleClick = this.handleClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields, personalized } = nextProps;
    if (listingFields != undefined) {
      this.setState({
        roomType: listingFields.roomType,
        personCapacity: listingFields.personCapacity
      });
    }
    if (personalized?.isOneTotalToggle) this.setState({ isOneTotalToggle: personalized?.isOneTotalToggle })
  }

  UNSAFE_componentWillMount() {
    const { listingFields, personalized } = this.props;
    if (detectMobileBrowsers.isMobile() === true) {
      this.setState({ mobileDevice: true });
    }
    if (listingFields != undefined) {
      this.setState({
        roomType: listingFields.roomType,
        personCapacity: listingFields.personCapacity
      });
    }
    if (personalized?.isOneTotalToggle) this.setState({ isOneTotalToggle: personalized?.isOneTotalToggle })
  }

  componentWillUnmount() {
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      window.removeEventListener('resize', this.handleResize);
    }
  }


  handleResize(e) {
    let isBrowser = typeof window !== 'undefined';
    let smallDevice = isBrowser ? window.matchMedia('(max-width: 767px)').matches : true;
    let verySmallDevice = isBrowser ? window.matchMedia('(max-width: 480px)').matches : false;

    this.setState({
      smallDevice,
      verySmallDevice
    });
  }

  handleClick() {
    const { personalized, setPersonalizedValues, change } = this.props;
    let updatedURI, uri = '/s?';

    if (personalized?.chosen) {
      uri = uri + '&address=' + personalized?.location + '&chosen=' + personalized?.chosen;
    } else {
      if (personalized?.location) {
        uri = uri + '&address=' + personalized?.location;
      }
    }

    if (personalized?.startDate && personalized?.endDate) {
      setPersonalizedValues({ name: 'isOneTotalToggle', value: true });
      change('SearchForm', 'isOneTotalToggle', true);
      uri = uri + '&startdate=' + personalized?.startDate + '&enddate=' + personalized?.endDate;
    }

    if (personalized?.personCapacity && !isNaN(personalized?.personCapacity)) {
      uri = uri + '&guests=' + personalized?.personCapacity;
    }

    updatedURI = encodeURI(uri);
    history.push(updatedURI);
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
        <FormControl {...input} placeholder={label} type={type} className={className} />
      </div>
    )
  }

  onSuggestSelect = (data, value) => {
    const { setPersonalizedValues } = this.props;
    searchFormSuggestSelect({ data, setPersonalizedValues, value });
  }

  onChange = async (value) => {
    const { setPersonalizedValues, change } = this.props;
    if (value == '') {
      changeSearchForm({ setPersonalizedValues, change });
    }
  }

  render() {

    const { setPersonalizedValues, personalized, id } = this.props;
    const { formatMessage } = this.props.intl;
    const { personCapacity, smallDevice } = this.state;
    let rows = [], startValue, endValue;

    if (personCapacity?.[0] && personCapacity[0]?.startValue) {
      for (let i = personCapacity[0]?.startValue; i <= personCapacity[0]?.endValue; i++) {
        rows.push(<option value={i} key={i}>{i} {i > 1 ? personCapacity[0]?.otherItemName : personCapacity[0]?.itemName}</option>);
        startValue = personCapacity[0]?.startValue;
        endValue = personCapacity[0]?.endValue;
      }
    }

    return (
      <div className={'layout5Css'}>
        <div className={cx('homeSearchForm', 'verticalsearchform', 'layout5Searchform')}>
          <div className={cx(s.searchForm, 'searchForm')}>
            <div className={cx('tableCellRTL', 'layout5DateWidth', s.GeoSuggestMobileFormItem, s.sideBorder, 'sideBorder', 'geoSuggestSideBorder')}>
              <label className={cx(s.label, s.whereLabelPadding)}>
                <span> <FormattedMessage {...messages.where} /></span>
              </label>
              <PlaceGeoSuggest
                placeholder={formatMessage(messages.homeWhere)}
                className={cx(s.formControlInput, s.layout2LocationSuggestInput, s.input, 'newGeoSuggestInput', s.textEllipsis)}
                id={'homeSearch' + id}
                initialValue={personalized?.location}
                onChange={this.onChange}
                onSuggestSelect={this.onSuggestSelect}
                containerClass={"geoSuggestLayout5"}
              />
            </div>
            <div className={cx('layout5SearchformLocationTwo', 'layout5DateWidth', s.mobileFormItem, s.sideBorder, 'sideBorder')}>
              <label className={cx(s.label, s.dateLabel)}>
                <span> <FormattedMessage {...messages.when} /></span>
              </label>
              <span className={cx('homeDate', s.formControlInput, s.input, 'homeDateAR', 'homeSerachDate')}>
                {
                  !smallDevice && <DateRange
                    formName={'SearchForm'}
                    numberOfMonths={2}
                  />
                }

                {
                  smallDevice && <MobileDateRange
                    formName={'SearchForm'}
                    numberOfMonths={1}
                  />
                }

              </span>
            </div>
            <div className={s.mobileFormItem}>
              <label className={cx(s.selectPadding, s.label, 'inputSpace')}>
                <span> <FormattedMessage {...messages.guest} /></span>
              </label>
              <FormControl
                componentClass="select"
                className={cx(s.formControlSelect, s.input, s.inputPadding, 'inputPaddingAR', 'inputSpace', 'inputPaddingRTL')}
                onChange={(e) => setPersonalizedValues({ name: 'personCapacity', value: Number(e.target.value) })}
                defaultValue={personalized.personCapacity}
                value={personalized.personCapacity}
              >
                {rows}
              </FormControl>
            </div>
            <div className={s.buttonContainer}>
              <Button className={cx(bt.btnPrimary, s.btnBlock, s.searchButton, 'layOut5SearchBtn')} onClick={this.handleClick}>
                <img src={searchIcon} />
                <span> <FormattedMessage {...messages.search} /></span>
              </Button>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

SearchForm = reduxForm({
  form: 'HomeSearchForm', // a unique name for this form
})(SearchForm);

const mapState = (state) => ({
  personalized: state.personalized,
  settingsData: state.viewListing.settingsData,
  listingFields: state.listingFields.data,
  isOneTotalToggle: state.personalized.isOneTotalToggle,
});

const mapDispatch = {
  setPersonalizedValues,
  change
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  (connect(mapState, mapDispatch))
)(SearchForm);